import { KEY_SEPARATOR } from 'app/shared/consts/translations';

export function getTranslationKey(...parts: string[]): string {
  return parts.join(KEY_SEPARATOR);
}
